import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 3 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 4 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 5 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 6 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 8 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 9 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 10 }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 11 }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["action"]

import { ref, onMounted, nextTick } from 'vue';
  import { useRoute } from 'vue-router';
  import { useStorage } from 'vue3-storage';
  import { CallbackResult } from 'vue3-storage/dist/lib/types';
  import axios from 'axios';
  import qs from 'qs';

  import HomeView from '@/views/HomeView.vue';
  import ShoppingCart from '@/components/ShoppingCart.vue';
  import TimezoneErrorModal from '@/components/TimezoneErrorModal.vue';
  import ConfirmCancelModal from '@/components/ConfirmCancelModal.vue';
  import LoginBox from '@/components/LoginBox.vue';
  import CarouselBox from '@/components/CarouselBox.vue';
  import NoticeBox from '@/components/NoticeBox.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const route = ref(useRoute());
  const axiosOptions = {
    withCredentials: true
    // headers: {'Access-Control-Allow-Origin': '*'}
  };
  let linkBaseURL = '';
  if (window.webtanEventConfig) {
    if (window.webtanEventConfig.api && window.webtanEventConfig.api.baseUrl) {
      axiosOptions.baseURL = window.webtanEventConfig.api.baseUrl;
      axiosOptions.baseURL = axiosOptions.baseURL.trim();
      if (axiosOptions.baseURL.match(/\/$/)) {
        axiosOptions.baseURL = axiosOptions.baseURL.slice(0, -1);
      }
    }
    if (window.webtanEventConfig.auth && window.webtanEventConfig.auth.username && window.webtanEventConfig.auth.password) {
      axiosOptions.auth = {};
      axiosOptions.auth.username = window.webtanEventConfig.auth.username;
      axiosOptions.auth.password = window.webtanEventConfig.auth.password;
    }
    if (window.webtanEventConfig.link && window.webtanEventConfig.link.baseUrl) {
      linkBaseURL = window.webtanEventConfig.link.baseUrl;
      linkBaseURL = linkBaseURL.trim();
      if (linkBaseURL.match(/\/$/)) {
        linkBaseURL = linkBaseURL.slice(0, -1);
      }
    }
  }
  let eventHolding = ref(true); // イベントが開催中かどうか
  if (window.webtanEventHolding === false) { // 終了している
    eventHolding.value = false;
  }
  if (window.webtanEventAPIisAlive === false) { // 静的化されている
    eventHolding.value = false; // 強制的にクローズ
  }
  let eventAPIisAlive = ref(true); // イベントが静的化されているかどうか
  if (window.webtanEventAPIisAlive === false) { // 静的化されている
    eventAPIisAlive.value = false;
  }

  const cart = ref([]);
  const makeStrageKey = () => {
    const url = 'webtan_' + encodeURIComponent(window.location.pathname.split('/').join('_'));
    return url;
  };
  const storageName = makeStrageKey();
  const date = new Date();
  date.setDate(60);
  const expireDate = date.toString();
  const storage = useStorage();

  let sessions = ref([]); // 全セッションのリスト
  let single = ref(false); // 詳細ページかどうか

  const entryList = ref([]); // 申込済リスト
  let concatList = ref([]); // カート + 申込済リスト

  let shareURL = ref('');
  let seminar_session = ref('');
  const isSingle = () => {
    // useRoute() が一瞬ずらさないとURLを把握しないことがあるため手動で解析する
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (queryParams.seminar_session) {
      single.value = true;
      seminar_session.value = queryParams.seminar_session.replace('seminar_', '');
    }
    // シェア用URL
    shareURL.value = window.location.protocol + window.location.hostname + window.location.pathname;
    if (queryParams.seminar_session) {
      shareURL.value = shareURL.value + '?seminar_session=' + queryParams.seminar_session;
    }
  }
  isSingle(); // 即時に実行する

  const webtanForm = ref();

  const login = ref(false);

  const timetableTopGuest = ref();
  const timetableBottomGuest = ref();
  const timetableTopLogin = ref();
  const timetableBottomLogin = ref();
  const singleTopGuest = ref();
  const singleBottomGuest = ref();
  const singleTopLogin = ref();
  const singleBottomLogin = ref();
  const eventEndedNotice = ref();

  const webtanPlayWebinarLabels = window.webtanPlayWebinarLabels;
  let webinarMainLabel = ref('視聴する');
  let webinarSubLabel = ref('');
  if (webtanPlayWebinarLabels) {
    if (webtanPlayWebinarLabels.webinarMainLabel != undefined || webtanPlayWebinarLabels.webinarMainLabel != null) { // 空文字の代入を許す
      webinarMainLabel.value = webtanPlayWebinarLabels.webinarMainLabel;
    }
    if (webtanPlayWebinarLabels.webinarSubLabel != undefined || webtanPlayWebinarLabels.webinarSubLabel != null) { // 空文字の代入を許す
      webinarSubLabel.value = webtanPlayWebinarLabels.webinarSubLabel;
    }
  }

  let timezoneError = ref(false);
  let timezoneErrorMessage = ref('');
  let confirmCancel = ref(false);
  let confirmCancelMessage = ref('');
  let cancelSession = ref({});

  const closeTimezoneErrorModal = () => {
    timezoneError.value = false;
  }

  const colseConfirmCancelModal = () => {
    confirmCancel.value = false;
  }

  let shoppingCart = ref(false);
  const toggleShoppingCart = () => {
    shoppingCart.value = !shoppingCart.value;
  }

  const setStorage = () => {
    storage
      .setStorage({
        key: storageName,
        data: { cart: cart.value, expire: expireDate }
      })
      .then((successCallback: CallbackResult) => {
        console.log(successCallback.errMsg);
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
      });
  }

  const removeStorage = () => { // 期限切れのとき初期化する
    storage
      .removeStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
        console.log(successCallback.errMsg);
        setStorage(); // 空値を保存してキーをつくる
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
      });
  }

  const getStorage = () => {
    storage
      .getStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
        console.log(successCallback.errMsg);
        if (new Date(successCallback.data.expire) < new Date()) {
          removeStorage();
          cart.value = [];
        } else {
          cart.value = successCallback.data.cart;
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
        // 初回のアクセス（キーがないとき）はこちらに来る
        setStorage(); // 空値を保存してキーをつくる
      });
  }

  const getStorageFromServer = () => {
    axios.get("/get_regedsemi.php", axiosOptions)
      .then((response) => {
        if (response.status == 200) {
          if (response.data) {
            entryList.value = response.data.data;
            // カート内にある重複するセッションは削除する
            if (cart.value) {
              entryList.value.forEach((row) => {
                const index = cart.value.indexOf(row);
                if (index != -1) {
                  cart.value.splice(index, 1);
                }
              });
            }
            setStorage();
            console.log('entryList.value', entryList.value);
          } else {
            entryList.value = [];
          }
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
      });
  }

  const addItem = (item: string) => {
    const checkDuplicatesAndSetStorage = () => {
      concatList.value = cart.value.concat(entryList.value);
      if (concatList.value) {
        let exist = false;
        concatList.value.forEach((row) => {
          if (row === item) {
            exist = true;
          }
        });
        if (exist) {
          timezoneError.value = true;
          timezoneErrorMessage.value = "このセッションはすでに視聴リストに追加されています。";
        } else {
          let enable = true;
          let sortkey = 0;
          sessions.value.forEach((session) => {
            if (item === session.layout_id) {
              sortkey = session.sortkey;
            }
          });
          concatList.value.forEach((row) => {
            sessions.value.forEach((session) => {
              if (row === session.layout_id) {
                if (sortkey === session.sortkey) {
                  enable = false;
                }
              }
            });
          });
          if (enable) {
            cart.value.push(item);
            concatList.value = cart.value.concat(entryList.value);
            setStorage();
            if (!shoppingCart.value) {
              shoppingCart.value = true;
            }
          } else {
            timezoneError.value = true;
            timezoneErrorMessage.value = "同じ時間帯のセッションは重複して追加できません。視聴リストから同じ時間帯のセッションを削除してから追加してください。";
          }
        }
      }
    }
    storage
      .getStorage({key: storageName})
      .then((successCallback: CallbackResult) => {
        console.log(successCallback.errMsg);
        cart.value = successCallback.data.cart;
        if (login.value) {
          // サーバーから保存された申し込み済みリストを取得する
          axios.get("/get_regedsemi.php", axiosOptions)
            .then((response) => {
              if (response.status == 200) {
                if (response.data) {
                  entryList.value = response.data.data;
                } else {
                  entryList.value = [];
                }
                checkDuplicatesAndSetStorage();
              }
            })
            .catch((failCallback: CallbackResult) => {
              console.log(failCallback.errMsg);
            });
        } else {
          checkDuplicatesAndSetStorage();
        }
      })
      .catch((failCallback: CallbackResult) => {
        console.log(failCallback.errMsg);
        // 初回のアクセス（キーがないとき）はこちらに来る
        setStorage(); // 空値を保存してキーをつくる
      });
  }

  const removeItem = (item: string) => {
    if (cart.value) {
      const index = cart.value.indexOf(item);
      if (index != -1) {
        cart.value.splice(index, 1);
      }
    }
    setStorage();
    if (!shoppingCart.value) {
      shoppingCart.value = true;
    }
  }

  const cancelItem = (session: object) => {
    confirmCancelMessage.value = '<div class="mb-3">以下のセッションの視聴をキャンセルしてよろしいですか？</div>' + '<div class="fw-bold">' + session.id + '<br>' + session.title + '</div>';
    cancelSession.value = session;
    confirmCancel.value = true;
  }

  const doCancelSession = (session: object) => {
    axios.get("/get_cancelsemi.php?layout_id=" + session.layout_id, axiosOptions) // セッションキャンセルAP, axiosOptionsI
      .then((response) => {
        if (response.status == 200) {
          if (response.data.result === true) {
            if (entryList.value) {
              const index = entryList.value.indexOf(session.layout_id);
              if (index != -1) {
                entryList.value.splice(index, 1);
              }
            }
            if (!shoppingCart.value) {
              shoppingCart.value = true;
            }
          } else {
            console.log('セッションのキャンセルに失敗しました。');
          }
        }
      })
      .catch((failCallback) => {
        console.log(failCallback.errMsg);
      });
  }

  const getSessions = () => {
    const makeSortKey = (temp) => {
      let tempAry = [];
      temp.forEach((session) => {
        // ソートキーをつくる
        const date = session.date.split('-');
        const time = session.timeStart.split(':');
        const d = new Date();
        d.setFullYear(date[0]);
        d.setMonth(parseInt((date[1]) - 1));
        d.setDate(parseInt(date[2]));
        d.setHours(time[0]);
        d.setMinutes(parseInt(time[1]));
        session.sortkey = d.getFullYear().toString() + d.getMonth().toString().padStart(2, '0') + d.getDate().toString().padStart(2, '0') + d.getHours().toString().padStart(2, '0') + d.getMinutes().toString().padStart(2, '0');
        tempAry.push(session);
      });
      tempAry.sort((a, b) => {
        return a.sortkey - b.sortkey;
      });
      return tempAry;
    }
    if (eventAPIisAlive.value === false) {
      let staticSessionsJSON = [];
      if (window.webtanEventStaticJSON) {
        staticSessionsJSON = makeSortKey(window.webtanEventStaticJSON);
      }
      sessions.value = staticSessionsJSON;
    } else {
      axios.get("/get_session.php", axiosOptions)
        .then((response) => {
          if (response.status == 200) {
            sessions.value = makeSortKey(response.data);
          }
        })
        .catch((failCallback) => {
          console.log(failCallback.errMsg);
        });
    }
  }

  const getLoginStatus = () => {
    const replaceWebContents = () => {
      // Vue コントロール外の表示をコントロールする
      const css1 = document.getElementById('js-webtan-timetable-guest-css');
      const style1 = document.createElement('style');
      style1.innerHTML = css1.innerHTML;
      document.head.appendChild(style1);
      css1.remove();
      const css2 = document.getElementById('js-webtan-timetable-login-css');
      const style2 = document.createElement('style');
      style2.innerHTML = css2.innerHTML;
      document.head.appendChild(style2);
      css2.remove();
      const css3 = document.getElementById('js-webtan-single-guest-css');
      const style3 = document.createElement('style');
      style3.innerHTML = css3.innerHTML;
      document.head.appendChild(style3);
      css3.remove();
      const css4 = document.getElementById('js-webtan-single-login-css');
      const style4 = document.createElement('style');
      style4.innerHTML = css4.innerHTML;
      document.head.appendChild(style4);
      css4.remove();
      const dom1 = document.getElementById('js-webtan-timetable-top-guest');
      timetableTopGuest.value = dom1.innerHTML;
      dom1.remove();
      const dom2 = document.getElementById('js-webtan-timetable-bottom-guest');
      timetableBottomGuest.value = dom2.innerHTML;
      dom2.remove();
      const dom3 = document.getElementById('js-webtan-timetable-top-login');
      timetableTopLogin.value = dom3.innerHTML;
      dom3.remove();
      const dom4 = document.getElementById('js-webtan-timetable-bottom-login');
      timetableBottomLogin.value = dom4.innerHTML;
      dom4.remove();
      const dom5 = document.getElementById('js-webtan-single-top-guest');
      singleTopGuest.value = dom5.innerHTML;
      dom5.remove();
      const dom6 = document.getElementById('js-webtan-single-bottom-guest');
      singleBottomGuest.value = dom6.innerHTML;
      dom6.remove();
      const dom7 = document.getElementById('js-webtan-single-top-login');
      singleTopLogin.value = dom7.innerHTML;
      dom7.remove();
      const dom8 = document.getElementById('js-webtan-single-bottom-login');
      singleBottomLogin.value = dom8.innerHTML;
      dom8.remove();
      const dom9 = document.getElementById('js-webtan-event-ended-notice');
      eventEndedNotice.value = dom9.innerHTML;
      dom9.remove();
      const twitter = document.createElement('script');
      twitter.src = 'https://platform.twitter.com/widgets.js';
      twitter.charset = 'utf-8';
      twitter.async = true;
      document.head.appendChild(twitter);
      const facebook = document.createElement('script');
      facebook.innerHTML = '(function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0"; fjs.parentNode.insertBefore(js, fjs); }(document, "script", "facebook-jssdk"));';
      document.head.appendChild(facebook);
      const hatena = document.createElement('script');
      hatena.src = 'https://b.st-hatena.com/js/bookmark_button.js';
      hatena.charset = 'utf-8';
      hatena.async = 'async';
      document.head.appendChild(hatena);
      const line = document.createElement('script');
      line.src = 'https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js';
      line.charset = 'utf-8';
      line.async = 'async';
      line.defer = 'defer';
      document.head.appendChild(line);
      const note = document.createElement('script');
      note.src = 'https://cdn.st-note.com/js/social_button.min.js';
      note.charset = 'utf-8';
      note.async = 'async';
      document.head.appendChild(note);
    }
    if (eventAPIisAlive.value === false) {
      login.value = false;
      replaceWebContents();
    } else {
      axios.get("/get_logined.php", axiosOptions)
        .then((response) => {
          if (response.status == 200) {
            login.value = response.data.status;
            
            // 検証用モード
            if (route.value.query.mode === 'login') {
              // 開発モードでひらいたときはログオフ時と同じ表示にする
              login.value = true;
            }
            
            if (login.value) {
              // ブラウザストレージから保存されたカート情報を取得する
              getStorage();
              // サーバーから保存された申し込み済みリストを取得する
              getStorageFromServer();
            } else {
              // ブラウザストレージから保存されたカート情報を取得する
              getStorage();
            }
            nextTick(() => {
              concatList.value = cart.value.concat(entryList.value);
              replaceWebContents();
            });
          }
        })
        .catch((failCallback) => {
          console.log(failCallback.errMsg);
        });
    }
  }

  const findSession = (cart: string[]) => {
    let foundSessions = [];
    if (cart) {
      cart.forEach((row) => {
        sessions.value.forEach((session) => {
          if (row === session.layout_id) {
            foundSessions.push(session);
          }
        });
      });
    }
    foundSessions = foundSessions.sort((a, b) => {
      return a.sortkey - b.sortkey;
    });
    return foundSessions;
  }

  const submitForm = () => {
    const stringifyCart = () => {
      const layout_id_list = [];
      const sessions = findSession(cart.value);
      sessions.forEach((session) => {
        layout_id_list.push(session.layout_id);
      });
      const data = JSON.stringify(layout_id_list);
      const dom = document.createElement('input');
      dom.type = 'hidden';
      dom.name = 'data';
      dom.value = data;
      webtanForm.value.appendChild(dom);
      const entry_layout_id_list = [];
      const entrySessions = findSession(entryList.value);
      entrySessions.forEach((session) => {
        entry_layout_id_list.push(session.layout_id);
      });
      const entryData = JSON.stringify(entry_layout_id_list);
      const entryDom = document.createElement('input');
      entryDom.type = 'hidden';
      entryDom.name = 'entryList';
      entryDom.value = entryData;
      webtanForm.value.appendChild(entryDom);
      nextTick(() => {
        console.log('data', data);
        console.log('entryData', entryData);
        webtanForm.value.submit();
      });
    }
    if (cart.value.length) {
      stringifyCart();
    } else {
      timezoneError.value = true;
      timezoneErrorMessage.value = "視聴するセッションを選んでから「参加申込する」ボタンを教えください。";
    }
  }

  onMounted (() => {
    isSingle();
    getLoginStatus();
    getSessions();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(sessions) && _unref(eventHolding) && _unref(eventAPIisAlive))
      ? (_openBlock(), _createBlock(ShoppingCart, {
          key: 0,
          cart: cart.value,
          entryList: entryList.value,
          sessions: _unref(sessions),
          onRemoveItem: removeItem,
          onCancelItem: cancelItem,
          onToggleShoppingCart: toggleShoppingCart,
          shoppingCart: _unref(shoppingCart),
          onSubmitForm: submitForm,
          login: login.value,
          webinarMainLabel: _unref(webinarMainLabel),
          webinarSubLabel: _unref(webinarSubLabel)
        }, null, 8, ["cart", "entryList", "sessions", "shoppingCart", "login", "webinarMainLabel", "webinarSubLabel"]))
      : _createCommentVNode("", true),
    (!_unref(eventHolding))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (eventEndedNotice.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: eventEndedNotice.value
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(eventAPIisAlive))
      ? (_openBlock(), _createBlock(LoginBox, {
          key: 2,
          login: login.value,
          linkBaseURL: _unref(linkBaseURL)
        }, null, 8, ["login", "linkBaseURL"]))
      : _createCommentVNode("", true),
    (!login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (timetableTopGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableTopGuest.value
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createVNode(CarouselBox, { login: login.value }, null, 8, ["login"])
        ]))
      : _createCommentVNode("", true),
    (login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(NoticeBox, { axiosOptions: axiosOptions }),
          (timetableTopLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableTopLogin.value
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (singleTopGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleTopGuest.value
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (singleTopLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleTopLogin.value
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(sessions))
      ? (_openBlock(), _createBlock(HomeView, {
          key: 7,
          single: _unref(single),
          cart: cart.value,
          entryList: entryList.value,
          sessions: _unref(sessions),
          seminar_session: _unref(seminar_session),
          shareURL: _unref(shareURL),
          onAddItem: addItem,
          onRemoveItem: removeItem,
          onCancelItem: cancelItem,
          onSubmitForm: submitForm,
          login: login.value,
          webinarMainLabel: _unref(webinarMainLabel),
          webinarSubLabel: _unref(webinarSubLabel),
          eventHolding: _unref(eventHolding),
          eventAPIisAlive: _unref(eventAPIisAlive),
          linkBaseURL: _unref(linkBaseURL)
        }, null, 8, ["single", "cart", "entryList", "sessions", "seminar_session", "shareURL", "login", "webinarMainLabel", "webinarSubLabel", "eventHolding", "eventAPIisAlive", "linkBaseURL"]))
      : _createCommentVNode("", true),
    (!login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (timetableBottomGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableBottomGuest.value
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && !_unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (timetableBottomLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: timetableBottomLogin.value
              }, null, 8, _hoisted_14))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (singleBottomGuest.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleBottomGuest.value
              }, null, 8, _hoisted_16))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (login.value && _unref(single))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (singleBottomLogin.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: singleBottomLogin.value
              }, null, 8, _hoisted_18))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      action: _unref(linkBaseURL) + '/',
      method: "post",
      class: "d-none",
      ref_key: "webtanForm",
      ref: webtanForm
    }, null, 8, _hoisted_19),
    (_unref(timezoneError))
      ? (_openBlock(), _createBlock(TimezoneErrorModal, {
          key: 12,
          onCloseTimezoneErrorModal: closeTimezoneErrorModal,
          message: _unref(timezoneErrorMessage)
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(confirmCancel))
      ? (_openBlock(), _createBlock(ConfirmCancelModal, {
          key: 13,
          onColseConfirmCancelModal: colseConfirmCancelModal,
          message: _unref(confirmCancelMessage),
          cancelSession: _unref(cancelSession),
          onDoCancelSession: doCancelSession
        }, null, 8, ["message", "cancelSession"]))
      : _createCommentVNode("", true)
  ]))
}
}

})